var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 24.6667L24.3703 22.8184C24.5659 21.8408 25.0886 20.9397 25.275 19.9604C25.3137 19.7573 25.3338 19.5477 25.3338 19.3333C25.3338 17.4924 23.8414 16 22.0005 16C20.1595 16 18.6671 17.4924 18.6671 19.3333C18.6671 19.5477 18.6874 19.7573 18.7261 19.9604C18.9125 20.9397 19.4351 21.8408 19.6307 22.8184L20.0005 24.6667M24.0005 24.6667H20.0005M24.0005 24.6667L27.3289 25.5545C28.5001 25.8148 29.3334 26.8536 29.3334 28.0535C29.3334 28.7603 28.7603 29.3333 28.0535 29.3333H27.3289H16.6667H15.9466C15.2398 29.3333 14.6667 28.7603 14.6667 28.0535C14.6667 26.8536 15.5001 25.8148 16.6713 25.5545L20.0005 24.6667",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 12.0001V10.6667C22.6667 6.89551 22.6667 5.00989 21.4951 3.83832C20.3235 2.66675 18.4379 2.66675 14.6667 2.66675H10.6667C6.89551 2.66675 5.00989 2.66675 3.83832 3.83832C2.66675 5.00989 2.66675 6.89551 2.66675 10.6667V21.3334C2.66675 25.1046 2.66675 26.9902 3.83832 28.1618C5.00989 29.3334 6.89551 29.3334 10.6667 29.3334",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 11.5556C9.33325 11.5556 10.1666 11.5556 10.9999 13.3333C10.9999 13.3333 13.647 8.88889 15.9999 8",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.6667H13.3333",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.6667H13.3333",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.589a94972458a2404ac9b2af9b35f19a.svg";
export { ForwardRef as ReactComponent };